import type { StateStorage } from "zustand/middleware";
import { createZustandIdbStateStorage } from "./zustandIdbJsonStorage";

/** Sliding idle TTL for Explorer filter persistence. */
export const EXPLORER_SESSION_TTL_MS = 60 * 60 * 1000;

/**
 * IndexedDB Zustand storage that discards persisted state when `state.savedAt`
 * is older than `ttlMs` (or missing / zero). Returning null lets Zustand use
 * in-memory defaults.
 */
export function createZustandIdbStateStorageWithTtl(
  ttlMs: number = EXPLORER_SESSION_TTL_MS,
): StateStorage {
  const base = createZustandIdbStateStorage();

  return {
    getItem: async (name) => {
      const raw = await base.getItem(name);
      if (raw == null) return null;
      try {
        const parsed = JSON.parse(raw) as {
          state?: { savedAt?: number };
          version?: number;
        };
        const savedAt = parsed?.state?.savedAt ?? 0;
        if (!savedAt || Date.now() - savedAt > ttlMs) {
          return null;
        }
        return raw;
      } catch {
        return null;
      }
    },
    setItem: (name, value) => base.setItem(name, value),
    removeItem: (name) => base.removeItem(name),
  };
}
